// sydm2に依存するロジックを集約します。

// お名前掲載に関するコースオプションの場合のみtrue
export const isOnamaeOption = (question: string): boolean => {
  return question.includes("お名前掲載");
};
